import { render, staticRenderFns } from "./T-F-Under-Grad-2024-CN.vue?vue&type=template&id=fa31a05c&scoped=true"
import script from "./T-F-Under-Grad-2024-CN.vue?vue&type=script&lang=js"
export * from "./T-F-Under-Grad-2024-CN.vue?vue&type=script&lang=js"
import style0 from "./T-F-Under-Grad-2024-CN.vue?vue&type=style&index=0&id=fa31a05c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa31a05c",
  null
  
)

export default component.exports